import { openModal } from '~/composables/modal';

// Loads a footnote via our (cached) API route and shows it in the global modal.
export const openFootnote = async (id: string) => {
  try {
    const { heading, content } = await $fetch(`/api/footnote/${encodeURIComponent(id)}`);
    openModal({
      heading,
      content,
      bodyClass: 'unstyled-html',
      closeOnBackdrop: true,
    });
  } catch {
    // footnote not available – nothing to show
  }
};
